export enum ActionEndpoints {
  VIEW = 'udr_view_api.php',
  OPER = 'udr_oper_api.php',
  SQLREPORT2 = 'sqlreport2_api.php',
  SQLREPORT2_VIEW = 'sqlreport2_view_api.php',
}

export enum ViewActions {
  VIEWCOLLMAN = 'viewcollman',
  VIEWCLIENT = 'viewclient',
  VIEWLOAN = 'viewloan',
  VIEWAPPLICATION = 'viewapp',
  VIEWCOLLATERAL = 'viewcollateral',
  VIEW = 'view',
  PRINT = 'print',
}

export enum ReportingOperActions {
  ADDTOFAVOURITES = 'star',
  REMOVEFROMFAVOURITES = 'unstar',
}

export interface ViewCollmanServerData {
  Data: Array<{
    ID: number
    Title: string
  }>
}

export type AddToFavouritesParams = {
  ReportID: number
  HashSum_ReportID_: string
}

export type PrintReportingParams = {
  ReportID: number
  HashSum_ReportID_: string
}

export type RemoveFromFavouritesParams = AddToFavouritesParams

export type ReportingTypes = 'App' | 'Client' | 'Collateral' | 'Loan'
type ReportingHashSum = `HashSum_${ReportingTypes}ID_`
type ReportingIDType = {
  [ID in ReportingTypes]: number
}
type ReportingHashSumType = {
  [HashSumID in ReportingHashSum]: string
}

export type GenerateParams<ReportingType extends ReportingTypes> =
  | ({
      action: 'generate'
      ReportID: number
      HashSum_ReportID_: string
      CalcDate: string
      CalcDate2: string
      CCY: string
      SEC_UserID: number
      NodeID: number
    } & Pick<ReportingIDType, ReportingType> &
      Pick<ReportingHashSumType, `HashSum_${ReportingType}ID_`>)
  | {
      action: 'generateturnover'
      CalcDate: string
      CalcDate2: string
      CCY: string
      NodeID: number
      BalCodeIDChar: number | string
      AccNo: number
      AccTitle: string
      EQ: number
      ShowBalCodeTot: number
      BalCodeLevel: number
      ShowAccounts: number
      ShowAllAcc: number
      ShowOffbal: number
      IncludeReapprisals: number
      NegativeOnly: number
      IncludeFinResults: number
    }
  | {
      action: 'generatebalancesheet'
      CalcDate2: number
      BSID: number | string
      CCY: string
      Trial: number
      ShowBalCodes: number
      ShowAccounts: number
      ShowEmpty: number
      RND: number | string
    }
  | {
      action: 'generateincomestatement'
      BSID: number | string
      CalcDate: string
      CalcDate2: string
      ShowBalCodes: number
      ShowAccounts: number
      ShowEmpty: number
      TaxableOnly: number
      RND: number | string
    }

export type ReportsViewParams = {
  action: 'status' | 'viewerror' | 'view'
} & (
  | {
      Ident: number | string
    }
  | {
      JobID: number
      HashSum_JobID_: string
    }
)

export interface ReportsViewServerData {
  Data: {
    StatusID: number
    ExpireInPrTS: number
    ExpireNewTS: number
  }
}

export enum ReportsServiceErrorCode {
  GENERAL,
}

export interface ReportsFailure {
  message: string
}
